import React from 'react'
import { FormControl, Checkbox, FormControlLabel, Button } from '@mui/material'

const CheckStatusButtons = ({ value, onChange, disabled, width }) => {
    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            <Button
                variant={value === 1 ? 'contained' : 'outlined'}
                color="success"
                disabled={disabled}
                onClick={() => onChange(1)}
                sx={{minWidth: width || 'auto'}}
            >{'〇'}
            </Button>
            <Button
                variant={value === 0 ? 'contained' : 'outlined'}
                color="error"
                disabled={disabled}
                onClick={() => onChange(0)}
                sx={{minWidth: width || 'auto'}}
            >{'×'}
            </Button>
        </div>
    );
};

export default CheckStatusButtons